export const MENU_LIST = "/menu/";
export const CATEGORY_LIST = "/blog/category/";
export const BLOG_LIST = "/blog/posts/";
export const META_LIST = "/websites/meta/";
export const CONTACT_FORM = "/content/contact/";
